import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M13.6455 19.5547L13.7451 19.7539L13.9453 19.8545L15.7441 20.75L13.7451 21.7451L12.75 23.7441L11.8545 21.9453L11.7539 21.7451L11.5547 21.6455L9.75586 20.75L11.5547 19.8545L11.7539 19.7539L11.8545 19.5547L12.75 17.7559L13.6455 19.5547Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22.415 6.5L8.29395 20.6211C7.73135 21.1836 6.96745 21.5 6.17188 21.5H1.5L1.50098 16.8281C1.50111 16.0328 1.81662 15.2695 2.37891 14.707L16.501 0.584961L22.415 6.5ZM3.79395 16.1211C3.60667 16.3085 3.50109 16.5632 3.50098 16.8281L3.5 19.5H6.17188C6.43694 19.5 6.6914 19.3944 6.87891 19.207L8.58594 17.499L5.50098 14.4141L3.79395 16.1211Z","fillRule":"evenodd","clipRule":"evenodd"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M20.877 14.6221L23.9297 16L20.877 17.377L19.5 20.4297L18.1221 17.377L15.0703 16L18.1221 14.6221L19.5 11.5703L20.877 14.6221Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M6.07812 2.92188L8.24414 4L6.07812 5.07812L5 7.24414L3.92188 5.07812L1.75586 4L3.92188 2.92188L5 0.755859L6.07812 2.92188Z"}}]};

const AiEdit1Filled = Vue.extend<IconProps>({
  name: 'AiEdit1FilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'ai-edit-1-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default AiEdit1Filled;
